import { LoadState } from "../../../constants/enums";
import { IApprovalHistoryState } from "./approval-history.types";

export const defaultApprovalHistoryState: IApprovalHistoryState = {
  approval_hierarchy: {
    data: [],
    totalRecords: 0,
    message: "",
    loading: LoadState.NotLoaded,
    error: null,
  },
  module_activity: {
    data: [],
    totalRecords: 0,
    message: "",
    loading: LoadState.NotLoaded,
    error: null,
  },
};
